/* The link that opens a record's drawer on its screen: the screen reads `?open=` and selects the
 * matching row. Here rather than in the hook that reads it, so plain logic (the attention list)
 * can build links without pulling React in. useOpenRecord re-exports it. */
export function recordHref(path: string, value: string): string {
  return `${path}?open=${encodeURIComponent(value)}`;
}
